import styled from '@emotion/styled';
interface Props {
	noData?: boolean;
}

export const Container = styled.main<Props>`
	display: flex;
	flex-direction: column;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	justify-content: ${(props) => (props.noData ? 'center' : '')};
	@media (max-width: 900px) {
		padding: 6rem 2rem;
	}
`;

export const BackButton = styled.button`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 1.2rem 0;

	color: #01337d;
	text-align: center;
	font-size: 1.6rem;
	font-weight: 700;
	line-height: 100%;
	letter-spacing: -0.6px;

	background: none;
	border: none;
	cursor: pointer;
`;

export const TableBox = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const TableItem = styled.li`
	display: flex;
	flex-direction: row;
	padding: 1.2rem 0rem;
	gap: 1.2rem;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid rgba(173, 181, 189, 0.4);
	@media (max-width: 900px) {
		align-items: flex-start;
		flex-direction: column;
	}
`;
export const TableContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 140%;
	letter-spacing: -0.6px;
	.date {
		color: #868e96;
		font-size: 1.4rem;
		line-height: 100%;
	}
`;

export const Button = styled.button`
	height: 3.6rem;
	padding: 0 1.2rem;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
	@media (max-width: 900px) {
		width: 100%;
	}
`;
export const NoData = styled.p`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	padding-top: 8rem;
	white-space: nowrap;
`;
